module.exports = __webpack_public_path__ + "static/media/drive_moto.58ffc8c6.jpg";